

var SELECTOR_PREFIX_REGEXP = /^[a-z0-9_-]*$/gi;


export default function getRehydrationIndex(renderer) {
  if (renderer.selectorPrefix.length === 0 || renderer.selectorPrefix.match(SELECTOR_PREFIX_REGEXP) !== null) {
    return renderer.uniqueRuleIdentifier;
  }

  return -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/server/getRehydrationIndex.js
// module id = 49
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38